module.exports = __webpack_public_path__ + "img/guide_icon_1.2734974d.svg";